/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SwitchField from "components/SwitchField";

export default function Fields({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const { checkbox1, checkbox2, checkbox3, checkbox4, checkbox5, organizeName, taxId } = formField;

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={organizeName.type}
            name={organizeName.name}
            label={organizeName.label}
            value={values.organizeName}
            error={errors.organizeName && touched.organizeName}
            success={values.organizeName?.toString().length > 0 && !errors.organizeName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={taxId.type}
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name="cacBangKe1" label="Các bảng kê" value={values?.cacBangKe1} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name="cacBangKe2" label="Các bảng kê" value={values?.cacBangKe2} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox3.name} label={checkbox3.label} value={values.checkbox3} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name="cacBangKe3" label="Các bảng kê" value={values?.cacBangKe3} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox4.name} label={checkbox4.label} value={values.checkbox4} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name="cacBangKe4" label="Các bảng kê" value={values?.cacBangKe4} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox5.name} label={checkbox5.label} value={values.checkbox5} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="subtitle1">
            Hình thức gửi tệp (Chỉ gửi tệp theo 1 hình thức cho tất cả các tệp tờ khai)
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name="internet"
            label="Qua mạng internet"
            value={values?.internet}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue("trucTiep", false);
                setFieldValue("buuDien", false);
              }
              setFieldValue("internet", e.target.checked);
            }}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name="trucTiep"
            label="Trực tiếp"
            value={values?.trucTiep}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue("buuDien", false);
                setFieldValue("internet", false);
              }
              setFieldValue("trucTiep", e.target.checked);
            }}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField
            name="buuDien"
            label="Bưu điện"
            value={values?.buuDien}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue("trucTiep", false);
                setFieldValue("internet", false);
              }
              setFieldValue("buuDien", e.target.checked);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
